import FeatureBranch from '@/common/FeatureBranch';
import PageFooter from '@/common/PageFooter';
import PageHeader from '@/common/PageHeader';
import { useIsLoggedIn } from '~/context/common/UserContext';
import EvCarousel from './EvCarousel/EvCarousel';
import EvEligibility from './EvEligibilty';
import { DisclaimerText, Main } from './EvTaxCredit.styles';
import FrequentlyAskedQuestions from './FrequentlyAskedQuestions';
import Hero from './Hero';
import HowItWorks from './HowItWorks';
import HowToFind from './HowToFind';

export default function EvTaxCreditContainer() {
  const isLoggedIn = useIsLoggedIn();

  return (
    <>
      <FeatureBranch appName="merchui" className="max-w-[1440px]" />
      <div className="mx-auto max-w-[1440px]">
        <PageHeader isLoggedIn={isLoggedIn} />
        <Main>
          <Hero />
          <HowItWorks />
          <HowToFind />
          <EvEligibility />
          <EvCarousel />
          <FrequentlyAskedQuestions />
          <DisclaimerText>
            We hope you found this page helpful! This content is not meant to
            provide legal or tax advice. We do our best to provide accurate
            information, but please conduct your own research before transacting
            and consider talking to a qualified professional about your unique
            circumstances. All third-party websites referenced/linked on this
            page are the property of their respective owners and do not
            constitute or imply endorsement, sponsorship, or recommendation of
            Carvana.
          </DisclaimerText>
        </Main>
        <PageFooter />
      </div>
    </>
  );
}
